import { EventEmitter } from '@angular/core';
import { InteractionReportData, ReportSectionEnum } from '../../../../../models/measure/report';
import { CommonConstant } from '../../../../app.constants';
import { PdfExportService } from '../../../../services/export-pdf/pdf-export.service';
var InteractionReportComponent = /** @class */ (function () {
    function InteractionReportComponent(pdfService) {
        this.pdfService = pdfService;
        this.data = new InteractionReportData();
        this.numOfItemPerPage = CommonConstant.MAX_ITEM_PER_PAGE_REPORT;
        this.changePage = new EventEmitter();
        this.currentPage = 1;
    }
    InteractionReportComponent.prototype.ngOnInit = function () {
        // REVIEW: @Trung, is this the right way to do this?
        if (this.data && Array.isArray(this.data.posts)) {
            this.data.posts = this.data.posts.map(function (p) { return Object.assign({}, p, {
                relativepath: encodeURIComponent(p.relativepath),
                url: encodeURIComponent(p.url)
            }); });
        }
    };
    InteractionReportComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (this.data.posts.length === 0) {
            this.pdfService.incrementNumberReportReady("" + InteractionReportComponent.COMPONENT_NAME + this.pageIndex);
            return;
        }
        this.pdfService.imagedLoadedTrigger.subscribe(function (data) {
            if (data.component === "" + InteractionReportComponent.COMPONENT_NAME + _this.pageIndex
                && data.currentCounter === _this.data.posts.length) {
                _this.pdfService.incrementNumberReportReady("" + InteractionReportComponent.COMPONENT_NAME + _this.pageIndex);
            }
        });
    };
    Object.defineProperty(InteractionReportComponent.prototype, "haveNoData", {
        get: function () {
            return this.data.posts.length === 0 && (!this.pageIndex || this.pageIndex === 0);
        },
        enumerable: true,
        configurable: true
    });
    InteractionReportComponent.prototype.onChangePage = function (evt) {
        this.changePage.emit({
            reportSection: ReportSectionEnum.INTERACTION_REPORT,
            criteriaChange: { page_no: evt }
        });
    };
    Object.defineProperty(InteractionReportComponent.prototype, "maxPage", {
        get: function () {
            if (!this.data || !this.data.totalRows) {
                return 0;
            }
            var totalFullPage = Math.floor(this.data.totalRows / this.numOfItemPerPage);
            var hasPartialPage = (this.data.totalRows % this.numOfItemPerPage) > 0;
            return hasPartialPage ? totalFullPage + 1 : totalFullPage;
        },
        enumerable: true,
        configurable: true
    });
    InteractionReportComponent.prototype.calculateIndex = function (index) {
        // in pdf mode
        if (this.pageIndex === 0) {
            return this.pageIndex * CommonConstant.MAX_ROI_ITEM_IN_PDF_PAGE + index + 1;
        }
        else if (this.pageIndex > 0) {
            return this.pageIndex * CommonConstant.MAX_ROI_ITEM_IN_PDF_PAGE + index + this.pageIndex - 1;
        }
        else if (this.data.pageNo) {
            return (this.data.pageNo - 1) * this.numOfItemPerPage + index + 1;
        }
        else {
            return this.numOfItemPerPage + index + 1;
        }
    };
    Object.defineProperty(InteractionReportComponent.prototype, "isExportingPdfReport", {
        get: function () {
            return this.pdfService.exportingPdf;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InteractionReportComponent.prototype, "shouldShowHeader", {
        get: function () {
            return !this.pageIndex || this.pageIndex === 0;
        },
        enumerable: true,
        configurable: true
    });
    InteractionReportComponent.COMPONENT_NAME = 'InteractionReportComponent';
    return InteractionReportComponent;
}());
export { InteractionReportComponent };



// WEBPACK FOOTER //
// ./src/app/main/measure/contents/interaction-report/interaction-report.component.ts.pre-build-optimizer.js